import { render, staticRenderFns } from "./AccountHeader.vue?vue&type=template&id=bc243256&scoped=true&"
import script from "./AccountHeader.vue?vue&type=script&lang=js&"
export * from "./AccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccountHeader.vue?vue&type=style&index=0&id=bc243256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc243256",
  null
  
)

export default component.exports